import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Calculate the total items added from a product map
 * @method calculateTotal
 * @param  {Object}  payload  The map to calculate total from
 * @return {Number}              The count of products added
 */
export var calculateTotal = function calculateTotal(payload) {
  var quantity = payload.quantity,
      _payload$bundleItems = payload.bundleItems,
      bundleItems = _payload$bundleItems === void 0 ? [] : _payload$bundleItems;
  return parseInt(quantity, 10) + bundleItems.length;
};
/**
 * Flatten inherited state
 * @method flatten
 * @param  {State}  state  The nested state with inherited hierarchy
 * @return {State}         Flat state with no hierarchy
 */

export var flatten = function flatten() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return state.inherited ? _objectSpread(_objectSpread({}, state), flatten(state.inherited)) : state;
};